import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Row, Typography, Button, Dropdown, Tabs } from "antd";

import { useQuery } from "hooks";
import { EllipsisOutlined } from "@ant-design/icons";
import { Table } from "components/common";
import "./styles.less";
import { useEffect } from "react";
import { ContestColumn } from "components/Columns";
import { getContestListRequest } from "providers/ContestProvider/slice";
import MenuOverlay from "./MenuOverlay";
import SearchBar from "./SearchBar";

const { TabPane } = Tabs;

const ContestList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { contestList, pagination, isLoading } = useSelector(
    (state) => state.contestSlice
  );
  const { total } = pagination;
  console.log(contestList, "contestList");
  const [searchObject, setSearch] = useQuery(getContestListRequest, {
    arrayParams: ["status"],
  });
  
  useEffect(() => {
    dispatch(getContestListRequest({}));
  }, [dispatch]);

  const refetchList = () => {
    dispatch(
      getContestListRequest({
        ...searchObject,
        _t: Date.now(),
      })
    );
  };

  const contestListColumn = [
    ContestColumn.name,
    ContestColumn.startDate,
    ContestColumn.endDate,
    ContestColumn.status,
    ContestColumn.bannerImage,
    ContestColumn.description,
    ContestColumn.rules,
    ContestColumn.totalCandidates,
    ContestColumn.totalVotes,
  ];

  // Add the actions column with refetchList function
  const actionsColumn = ContestColumn.actions({ onRefresh: refetchList });

  const columns = [...contestListColumn, actionsColumn];

  return (
    <div className="sim-list-wrapper">
      <Row className="sim-list-header" justify="space-between">
        <Typography.Title level={4}>Danh sách cuộc thi</Typography.Title>
        <Row
          style={{ width: 300 }}
          className="sim-list-header"
          justify="space-between"
        >
          <Button
            size="large"
            type="primary"
            onClick={() =>
              navigate(`/contest/contest-create`, {
                state: { canGoBack: true },
              })
            }
          >
            Tạo cuộc thi
          </Button>
        </Row>
      </Row>
      <div className="content-container">
        <SearchBar searchObject={searchObject} type={searchObject.type} />
        <Table
          scroll={{ x: 1000 }}
          loading={isLoading}
          bordered
          columns={columns}
          dataSource={contestList}
          rowKey={(data) => data._id}
          total={total}
          onRow={(record) => ({
            onDoubleClick: () => {
              navigate(`/contest/${record._id}`, {
                state: { canGoBack: true },
              });
            },
          })}
        />
      </div>
    </div>
  );
};

export default ContestList;
